import axios, { AxiosInstance } from "axios"

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL

export const api: AxiosInstance = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    Accept: "text/plain",
    "Content-Type": "application/json-patch+json",
    "x-goto-device-id": "Web",
  },
})

export const updateApiHeaders = (
  token: string | undefined,
  customerToken: string | undefined,
) => {
  api.defaults.headers.common["x-Token"] = token
  api.defaults.headers.common["x-Customer"] = customerToken
}
